import { render, staticRenderFns } from "./SolicitudesPagosLayout.vue?vue&type=template&id=35335640&scoped=true"
import script from "./SolicitudesPagosLayout.vue?vue&type=script&lang=js"
export * from "./SolicitudesPagosLayout.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesPagosLayout.vue?vue&type=style&index=0&id=35335640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35335640",
  null
  
)

export default component.exports